class WgHeader extends HTMLElement {
  connectedCallback() {
    this.toggles = this.querySelectorAll('[data-wg-menu-toggle]');
    this.drawer = this.querySelector('[data-wg-drawer]');
    this.closeBtn = this.querySelector('[data-wg-drawer-close]');
    this.overlay = this.querySelector('[data-wg-drawer-overlay]');
    this.searchInput = this.querySelector('[data-wg-search-input]');
    this.searchFocus = this.querySelector('[data-wg-search-focus]');
    this.compactEnabled = this.dataset.compactOnScroll !== 'false';
    this.hideCatsOnScroll = this.dataset.hideCatsOnScroll !== 'false';
    this.lastY = window.scrollY || 0;
    this.mobileQuery = window.matchMedia('(max-width: 989px)');

    this.toggles.forEach((btn) => btn.addEventListener('click', () => this.open()));
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        const megaParent = this.querySelector('.wg-cat-wrap:focus-within a');
        megaParent?.blur();
      }
    });
    this.searchFocus?.addEventListener('click', () => {
      this.classList.add('is-search-open');
      this.searchInput?.focus();
      this.searchInput?.scrollIntoView({ block: 'nearest' });
    });

    this.onExtraToggle = (event) => {
      const extra = event.target.closest('[data-wg-menu-toggle]');
      if (!extra || this.contains(extra)) return;
      event.preventDefault();
      this.open();
    };
    document.addEventListener('click', this.onExtraToggle);

    if (this.compactEnabled) {
      this.onScroll = () => this.updateCompact();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateCompact();
    }

    this.querySelectorAll('.wg-cat-wrap.has-mega').forEach((wrap) => {
      const trigger = wrap.querySelector('.wg-cat');
      if (!trigger) return;
      const setOpen = (open) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.addEventListener('mouseenter', () => setOpen(true));
      wrap.addEventListener('mouseleave', () => setOpen(false));
      wrap.addEventListener('focusin', () => setOpen(true));
      wrap.addEventListener('focusout', (event) => {
        if (!wrap.contains(event.relatedTarget)) setOpen(false);
      });
    });
  }

  updateCompact() {
    const y = window.scrollY || 0;
    const isMobile = this.mobileQuery.matches;

    if (isMobile) {
      if (!this.hideCatsOnScroll) {
        this.classList.remove('is-compact');
        this.lastY = y;
        return;
      }

      const delta = y - this.lastY;
      if (y < 24) {
        this.classList.remove('is-compact');
      } else if (delta > 10 && y > 72) {
        this.classList.add('is-compact');
      } else if (delta < -10) {
        this.classList.remove('is-compact');
      }
      this.lastY = y;
      return;
    }

    this.classList.toggle('is-compact', y > 80);
    this.lastY = y;
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    if (this.onExtraToggle) document.removeEventListener('click', this.onExtraToggle);
  }

  open() {
    this.drawer?.classList.add('is-open');
    this.drawer?.setAttribute('aria-hidden', 'false');
    this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    this.closeBtn?.focus();
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.drawer?.setAttribute('aria-hidden', 'true');
    this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    this.classList.remove('is-search-open');
  }
}

class WgPredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-wg-search-input]');
    this.results = this.querySelector('[data-wg-search-results]');
    this.timer = null;
    this.input?.addEventListener('input', () => this.schedule());
    this.input?.addEventListener('focus', () => {
      if (this.input.value.trim().length >= 2) this.results.hidden = false;
    });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.results.hidden = true;
    });
  }

  schedule() {
    clearTimeout(this.timer);
    const query = this.input.value.trim();
    if (query.length < 2) {
      this.results.hidden = true;
      this.results.innerHTML = '';
      return;
    }
    this.timer = setTimeout(() => this.suggest(query), 180);
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  async suggest(query) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      const response = await fetch(url);
      if (!response.ok) return;
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        this.results.innerHTML = `<p class="wg-search__empty">Sin resultados</p>`;
        this.results.hidden = false;
        return;
      }
      this.results.innerHTML = products
        .map((product) => {
          const title = this.escapeHtml(product.title);
          const href = this.escapeHtml(product.url);
          const img = product.image
            ? `<img src="${this.escapeHtml(product.image)}" alt="" width="40" height="40">`
            : '';
          return `<a class="wg-search__hit" href="${href}">${img}<span>${title}</span></a>`;
        })
        .join('');
      this.results.hidden = false;
    } catch (error) {
      this.results.hidden = true;
    }
  }
}

if (!customElements.get('wg-header')) {
  customElements.define('wg-header', WgHeader);
}
if (!customElements.get('wg-predictive-search')) {
  customElements.define('wg-predictive-search', WgPredictiveSearch);
}
